import { render, staticRenderFns } from "./WealthDetail.vue?vue&type=template&id=4dfc7aa4"
import script from "./WealthDetail.vue?vue&type=script&lang=js"
export * from "./WealthDetail.vue?vue&type=script&lang=js"
import style0 from "./WealthDetail.vue?vue&type=style&index=0&id=4dfc7aa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports